// third-party
import { createSlice } from "@reduxjs/toolkit";
// project imports
import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const initialState = {
  users: [],
  error: null,
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

// Reducer
const slice = createSlice({
  name: "users",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },

    // GET USERS STYLE 1
    getSuccess(state, action) {
      state.users = utils.sortAlphatically(action.payload, "email");
      const total = action.payload.length;
      let pages = Math.floor(total / state.limit);
      const remainder = total % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },

    editSuccess(state, action) {
      state.loading = false;
    },

    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

// Actions
export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getUsers() {
  return async () => {
    try {
      const limit = 200;
      const firstCall = await axios.get(`/users?size=${limit}`);
      const res = await Promise.all(
        Array.from({
          length: Math.floor(firstCall.data.totalItems / limit),
        }).map((_, i) =>
          axios.get(`/users?size=${limit}&offset=${limit * (i + 1)}`)
        )
      ).then((data) => data);

      const allData = [
        ...firstCall.data.data,
        ...res.map((data) => data.data.data).flat(),
      ];

      dispatch(slice.actions.getSuccess(allData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGyms() {
  return async () => {
    try {
      const result = await axios.get(`/gyms?size=1000`);
      dispatch(slice.actions.getSuccess(result.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSpecialists() {
  return async () => {
    try {
      const result = await axios.get(`/specialists?size=1000`);
      dispatch(slice.actions.getSuccess(result.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function onDisableEnableUser(user, callback) {
  return async () => {
    try {
      await axios.put(`/users/active/${user.id}`, { active: !user.active });
      dispatch(getUsers());
    } catch (error) {
      dispatch(getUsers());
      stopLoading();
      dispatch(slice.actions.hasError(error));
    }
  };
}

// export function editExercise(id, data, navigate) {
//     return async () => {
//         try {
//             const result = await axios.put(`${BASE_URL}/${PATH}?exerciseId=${id}`, data);
//             console.log('RES [editExercise] =======> ', result?.data?.data);
//             dispatch(slice.actions.editSuccess(result?.data?.data));
//             navigate(navigateTo);
//         } catch (error) {
//             console.log('ERR [editExercise] ', error);
//             dispatch(slice.actions.hasError(error));
//         }
//     };
// }

// Admin-create a pre-verified user account (no email verification). Backend guards
// against colliding with an existing verified account. On success: refresh the list,
// show a success toast, and run onSuccess() (used to close the modal).
export function createVerifiedUser(data, onSuccess = () => {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post("/auth/create_verified_user", {
        email: data.email,
        password: data.password,
        name: data.name,
      });
      dispatch(slice.actions.stopLoading());
      utils.snackBarMsg(dispatch, "Account created", "success");
      onSuccess();
      dispatch(getUsers());
    } catch (error) {
      dispatch(slice.actions.stopLoading());
      // axios interceptor unwraps the rejection to response.data ({ message }).
      const msg = error?.message || error?.response?.data?.message || "Could not create account";
      utils.snackBarMsg(dispatch, msg, "error");
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
